import { MTGSetType } from "../enum";
import { IMTGSet, IMTGSets } from "../interface";
import { LARGE_SET_THRESHOLD } from "../lotto";

const NON_CARD_SETS = [
    MTGSetType.Vanguard,
    MTGSetType.Memorabilia,
    MTGSetType.Token,
];

export class MagicTheGatheringApi {

    public async getSets(): Promise<IMTGSet[]> {
        const remoteVersion = await this.getRemoteVersion();
        const localVersion = this.getLocalVersion();

        if (remoteVersion === localVersion) {
            return this.getLocalSet();
        } else {
            const newSet = await this.getPreparedRemoteSet();

            this.updateVersion(remoteVersion);
            this.updateSets(newSet);

            return newSet;
        }
    }

    private async getRemoteVersion(): Promise<string> {
        const request = await fetch("https://mtgjson.com/json/version.json");
        const { version } = await request.json();

        return version;
    }

    private getLocalVersion(): string {
        const localVersion = localStorage.getItem("gbc-version");
        if (localVersion) {
            return localVersion;
        }
        return "";
    }

    private async getRemoteSet(): Promise<IMTGSets> {
        const request = await fetch("https://mtgjson.com/json/AllSets.json");

        return request.json() as Promise<IMTGSets>;
    }

    private getLocalSet(): IMTGSet[] {
        const sets = localStorage.getItem("gbc-sets");

        if (sets) {
            return JSON.parse(sets) as IMTGSet[];
        } else {
            return [];
        }
    }

    private async getPreparedRemoteSet(): Promise<IMTGSet[]> {
        const remoteSets = await this.getRemoteSet();

        return this.prepareSets(Object.values(remoteSets));
    }

    private prepareSets(sets: IMTGSet[]): IMTGSet[] {
        const filteredSets: IMTGSet[] = [];

        for (const set of sets) {
            if (!NON_CARD_SETS.includes(set.type)) {
                if (set.totalSetSize > 0) {
                    filteredSets.push({
                        totalSetSize: set.totalSetSize,
                        code: set.code,
                        large: set.totalSetSize >= LARGE_SET_THRESHOLD,
                        name: set.name,
                        releaseDate: set.releaseDate,
                        type: set.type,
                    });
                }
            }
        }

        return filteredSets;
    }

    private updateVersion(version: string): void {
        localStorage.setItem("gbc-version", version);
    }

    private updateSets(set: IMTGSet[]): void {
        localStorage.setItem("gbc-sets", JSON.stringify(set));
    }
}
